import { render, staticRenderFns } from "./CalibrationsDetail.vue?vue&type=template&id=969cb530&scoped=true&"
import script from "./CalibrationsDetail.vue?vue&type=script&lang=js&"
export * from "./CalibrationsDetail.vue?vue&type=script&lang=js&"
import style0 from "./CalibrationsDetail.vue?vue&type=style&index=0&id=969cb530&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "969cb530",
  null
  
)

export default component.exports